import React from 'react';
import { useFormContext } from 'react-hook-form';
import { FeedbackListFieldSet } from '@/features/Collaborators/Edit/Form/Fieldsets';
import { CollaboratorFormContext } from "@/features/Collaborators/Edit/Contexts/CollaboratorFormContext";
import { CollaboratorFormData } from '@/features/Collaborators/Edit/Types';

interface FeedbackTabProps {
    context: CollaboratorFormContext;
}

const FeedbackTab: React.FC<FeedbackTabProps> = ({ context }) => {
    const {
        control,
        setValue,
        watch,
        trigger,
        formState: { errors, isSubmitting }
    } = useFormContext<CollaboratorFormData>();

    return (
        <div className="space-y-6">
            <FeedbackListFieldSet
                context={context}
            />
        </div>
    );
};

export default FeedbackTab;
